let spotifyApiPromise;

function loadSpotifyIframeAPI() {
    if (spotifyApiPromise) {
        return spotifyApiPromise;
    }

    spotifyApiPromise = new Promise(resolve => { // eslint-disable-line compat/compat
        const script = document.createElement('script');
        script.src = 'https://open.spotify.com/embed/iframe-api/v1';

        const previous = window.onSpotifyIframeApiReady;

        window.onSpotifyIframeApiReady = IFrameAPI => {
            previous?.(IFrameAPI);
            resolve(IFrameAPI);
        }

        document.head.appendChild(script);
    });

    return spotifyApiPromise;
}

const determineIframeOrigin = iframe => {
    const a = document.createElement('a');
    a.href = iframe.src;
    return a.protocol + '//' + a.hostname + (a.port ? ':' + a.port : '');
}

export default function () {
    document.addEventListener('close', event => {
        if (event.target.tagName !== 'DIALOG') {
            return;
        }

        for (const element of event.target.querySelectorAll('.js-work-audio-native, .js-work-audio-spotify')) {
            if (element.classList.contains('js-work-audio-native')) {
                element.pause();
            } else if (element.classList.contains('js-work-audio-spotify')) {
                element.contentWindow.postMessage({ command: 'pause' }, determineIframeOrigin(element));
            }
        }
    }, true);
}
